<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d); ">
    <div style="background-color: rgb(48, 124, 185); padding: 0 15vw;" class="contactHeader">
        <div class="green containerHeader">
            <div>
                Your Gateway to the Magical Land of Ecuador
            </div>
            <div>
                <a href="mailto:info&#64;midlandtravel.com.ec" target="_blank">
                    <i class="fa fa-envelope-o" style="padding: 0 10px;"></i>
                    info&#64;midlandtravel.com.ec</a>
            </div>
            <div>
                <a style="text-decoration: none; padding-right: 20px;" href="tel:59322905735" target="_blank">
                    <i class="fa fa-phone" style="padding: 0 10px;"></i>
                    (+593 2) 2 905 735</a>
            </div>
            <div style="font-size: 1.5em;">
                <a href="https://wa.me/+593984021324" target="_blank"><i class="fa fa-whatsapp"
                        style="padding: 0 10px;"></i></a>
                <a href="https://www.facebook.com/MidlandTravel/" target="_blank"><i class="fa fa-facebook"
                        style="padding: 0 10px;"></i></a>
                <a href="https://www.instagram.com/midlandtravel/" target="_blank"><i class="fa fa-instagram"
                        style="padding: 0 10px;"></i></a>
                <a href="https://maps.app.goo.gl/Jb5pgJr9Rh8TUata6" target="_blank"><i class="fa fa-google"
                        style="padding: 0 10px;"></i></a>
            </div>
        </div>
    </div>

    <div #header1 class="green containerMenu custom-container">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://midlandtravel.com.ec" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/mt.svg" alt="logo" class="brand-logo" style="height: 45px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit; justify-content: end;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/" target="_blank">Home</a></li>
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/galapagos/"
                        target="_blank">Galapagos</a></li>
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/amazon-rainforest/"
                        target="_blank">Amazon Rainforest</a></li>
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/andes-and-more/"
                        target="_blank">Andes
                        & More</a></li>
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/about-midland-travel/"
                        target="_blank">About</a>
                </li>
                <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/contact-us/" target="_blank">Contact
                        Us</a></li>
                <li class="nav-item menuItem rightButton"><a href="https://midlandtravel.com.ec" target="_blank">INQUIRE
                        NOW</a></li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader" style="justify-content: end; flex-direction: row!important;"
            class="responsiveHeader">
            <div style="font-size: 1.5em;">
                <a href="https://wa.me/+593984021324" target="_blank"><i class="fa fa-whatsapp"
                        style="padding: 0 10px;"></i></a>
                <a href="https://www.facebook.com/MidlandTravel/" target="_blank"><i class="fa fa-facebook"
                        style="padding: 0 10px;"></i></a>
                <a href="https://www.instagram.com/midlandtravel/" target="_blank"><i class="fa fa-instagram"
                        style="padding: 0 10px;"></i></a>
                <a href="https://maps.app.goo.gl/Jb5pgJr9Rh8TUata6" target="_blank"><i class="fa fa-google"
                        style="padding: 0 10px;"></i></a>
            </div>
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-2x" style="padding-right: 10px;"></i>
            </a>
        </div>

    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/" target="_blank">Home</a></li>
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/galapagos/" target="_blank">Galapagos</a>
        </li>
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/amazon-rainforest/" target="_blank">Amazon
                Rainforest</a></li>
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/andes-and-more/" target="_blank">Andes
                & More</a></li>
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/about-midland-travel/"
                target="_blank">About</a>
        </li>
        <li class="nav-item menuItem"><a href="https://midlandtravel.com.ec/contact-us/" target="_blank">Contact
                Us</a></li>
        <li class="nav-item menuItem rightButton"><a href="https://midlandtravel.com.ec" target="_blank">INQUIRE
                NOW</a></li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>